import styled from "styled-components";
import { Modal, Button } from "react-bootstrap";

export const ModalHeader = styled(Modal.Header)`
  border-bottom: none;
`;

export const ModalFooter = styled(Modal.Footer)`
  border-top: none;
`;
